// extracted by mini-css-extract-plugin
export default {"copy_button":"CopyToClipBoard_copy_button__u4Cvm","reverted":"CopyToClipBoard_reverted__HdTZz"};